import type { IconName } from "@similarweb/icons";

import type { IRankObjValueNewLostCell } from "app/components/React/Table/cells/NewAndLostChangeCell";
import type { IReportTableMetrics } from "app/pages/digital-marketing/keywords-campaigns/reports/shared/Table/TableUtils/RankTrackerTablesTypes";
import type { RTRawParams } from "app/pages/digital-marketing/keywords-campaigns/reports/types";

export interface IPagesReportRecordsData {
    url: string;
    topKeyword: string;
    keywordsCount: IRankObjValueNewLostCell;
    avgWeightPosition: IRankObjValueNewLostCell;
    clicks: IRankObjValueNewLostCell;
    volumeSum: number;
    intent: {
        [key: string]: number;
    };
    urlSerpFeatures: string[];
    lastUpdated: string;
    urlCount: number;
}

export interface PagesReportEnrichedTableRow extends IPagesReportRecordsData {
    keyword: { displayText: string; link: string };
    originalURL: string;
    volume: string;
    duration?: string;
    campaignGuid: string;
    SerpFeatures: string[];
    SiteSerpFeatures: Record<string, string[]>;
    SearchTerm: string;
    key: string;
    lastDayKeyword: { first: number; last: number; change: number };
    changeKeyword: IRankObjValueNewLostCell;
    lastDayClicks: string;
    changeClicks: IRankObjValueNewLostCell;
    lastDayAvgPos: string | number;
    changeAvgPos: IRankObjValueNewLostCell;
}

export type PagesReportMetricFields = Pick<
    PagesReportEnrichedTableRow,
    "lastDayKeyword" | "changeKeyword" | "lastDayClicks" | "changeClicks" | "lastDayAvgPos" | "changeAvgPos"
>;

export interface IPagesReportTableData {
    records: IPagesReportRecordsData[];
    totalCount: number;
}

interface IPagesReportExpendedTableRecordsData {
    keyword: string;
    organicPosition: IRankObjValueNewLostCell;
    overallPosition: IRankObjValueNewLostCell;
    volume: number;
    geoLocation: string;
    keywordSerpFeatures: string[];
    scrapingConfigurationId: string;
    url: string;
}

export interface IPagesReportExpendedTableResponse {
    records: IPagesReportExpendedTableRecordsData[];
    totalCount: number;
}

export enum EPagesReportTableTabs {
    ALL_RANKING = "NoChange",
    NEW_PAGES = "New",
    LOST_PAGES = "Lost",
}

export interface IPagesReportTableTab {
    title: string;
    iconName: IconName;
    name: EPagesReportTableTabs;
    disabled?: boolean;
    tooltipText?: string;
}

export enum EPagesReportTableMetrics {
    POSITION = "position",
    KEYWORD = "keyword",
    CLICKS = "clicks",
}

export interface IPagesReportTableMetrics extends IReportTableMetrics {
    metricID: EPagesReportTableMetrics;
    metricTitleKey: string;
    tooltipKey: string;
    lastDayKey: string;
    changeKey: string;
    metricAggregatedColumnNameKey: string;
}

export enum EPagesReportTableMetricsIndexes {
    KEYWORD,
    CLICKS,
    POSITION,
}

export type PagesReportRawParams = RTRawParams & {
    sortedColumn: keyof PagesReportEnrichedTableRow;
};
